import { Pipe, PipeTransform } from '@angular/core';
import { ClassificationService } from '@core/services/classification.service';

@Pipe({
  name: 'getOrgIcon'
})
export class GetOrgIconPipe implements PipeTransform {

  constructor (
    private classificationService: ClassificationService
  ) { }

  transform (org: {
    iconURL?: string;
    classification?: string;
  }) {
    return this.classificationService.getIconFromSearchResult(org);
  }
}
